export const NEARMAP_COVERAGE = 'NEARMAP_COVERAGE';
export const NEARMAP_COVERAGE_FAIL = 'NEARMAP_COVERAGE_FAIL';
export const NEARMAP_COVERAGE_SUCCESS = 'NEARMAP_COVERAGE_SUCCESS';
export const SET_SELECTED_NEARMAP_COVERAGE = 'SET_SELECTED_NEARMAP_COVERAGE';
export const CLEAR_NEARMAP_COVERAGE = 'CLEAR_NEARMAP_COVERAGE';

export const AUCKLAND_FLOOD_GEOJSON = 'AUCKLAND_FLOOD_GEOJSON';
export const AUCKLAND_FLOOD_GEOJSON_SUCCESS = 'AUCKLAND_FLOOD_GEOJSON_SUCCESS';

export const SET_EXPAND_MAP_FOR_HAZARDS = 'SET_EXPAND_MAP_FOR_HAZARDS';
export const SAVE_DRAWINGS = 'SAVE_DRAWINGS';
export const CLEAR_DRAWINGS = 'CLEAR_DRAWINGS';
export const SET_EMPTY_MAP_BUBBLE = 'SET_EMPTY_MAP_BUBBLE';

export function getNearmapCoverage(bounds) {
    return {
        type: NEARMAP_COVERAGE,
        payload: {
            bounds,
        },
    };
}

export function setSelectedNearmapCoverage(survey) {
    return {
        type: SET_SELECTED_NEARMAP_COVERAGE,
        payload: {
            selected: survey,
        },
    };
}

export function clearNearmapCoverage() {
    return {
        type: CLEAR_NEARMAP_COVERAGE,
    };
}

export function getAucklandFloodGeoJson({ bounds, signal = null, zoomLevel, isDisabled }) {
    return {
        type: AUCKLAND_FLOOD_GEOJSON,
        payload: {
            bounds, signal, zoomLevel, isDisabled,
        },
    };
}
export function getAucklandFloodGeoJsonSuccess(payload) {
    return {
        type: AUCKLAND_FLOOD_GEOJSON_SUCCESS, payload,
    };
}

export function setExpandMapForHazards(isHazardsMap) {
    return {
        type: SET_EXPAND_MAP_FOR_HAZARDS,
        payload: isHazardsMap,
    }
}

export function saveDrawings(payload) {
    return {
        type: SAVE_DRAWINGS,
        payload,
    }
}


export function clearDrawings() {
    return {
        type: CLEAR_DRAWINGS,
    }
}

export function setEmptyMapBubble(coordinates = null) {
    return {
        type: SET_EMPTY_MAP_BUBBLE,
        payload: coordinates,
    }
}